import React from 'react';

import { DoctorDetail } from '../components';

import siteBanner_img from '../assets/img/temp/siteBanner_img_4.jpg';

class DoctorDetailContainer extends React.Component {
  render() {
    const doctor = this.props.texts.langs.doctors.find(doc =>
      parseInt(doc.id) === parseInt(this.props.params.doctor));
    return (
      <div>
        <div className="siteBanner siteBanner_docs">
          <img src={siteBanner_img} className="siteBanner_bg"/>
          <h2 className="line">{doctor.name}</h2>
        </div>
        <DoctorDetail
          doctor={doctor}
        />
      </div>
    );
  }
}

export default DoctorDetailContainer;



// WEBPACK FOOTER //
// ./src/containers/DoctorDetail.js